(function() {
            var React = require('react');
            var ReactDOM = require('react-dom');
            var ReactRouterDOM = require('react-router-dom');
            var Router = ReactRouterDOM.BrowserRouter;
            var Route = ReactRouterDOM.Route;
            var History = require('history');

            var Plugin0 = require("D:/GIT/nodepress/dist/plugins/post/PostComponent.js");
var Plugin1 = require("D:/GIT/nodepress/dist/plugins/feed/FeedComponent.js");
var Plugin2 = require("D:/GIT/nodepress/dist/plugins/reader/ReaderComponent.js");
var Plugin3 = require("D:/GIT/nodepress/dist/plugins/user/login/LoginComponent.js");


            var element = (React.createElement(Router, null,
                React.createElement("div", null,
                    React.createElement(Route, { exact:true, path:"/post", component:Plugin0 }),
React.createElement(Route, { exact:true, path:"/", component:Plugin1 }),
React.createElement(Route, { exact:true, path:"/read/:post", component:Plugin2 }),
React.createElement(Route, { exact:true, path:"/login", component:Plugin3 })
                )
            ));
            
            ReactDOM.render(element, document.getElementById('root'));
        })();